export default __webpack_public_path__ + "static/media/vid8.bac92d55.mp4";